import { collection, doc, onSnapshot, orderBy, query } from 'firebase/firestore';
import { getFirestoreDb } from './firebase';

const toIsoTimestamp = (value) => {
  if (!value) return null;
  if (typeof value.toDate === 'function') return value.toDate().toISOString();
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString();
};

const mapChat = (id, row = {}) => ({
  id,
  ...row,
  created_at: toIsoTimestamp(row.created_at),
  updated_at: toIsoTimestamp(row.updated_at),
  last_message_at: toIsoTimestamp(row.last_message_at),
  closed_at: toIsoTimestamp(row.closed_at),
  archived_at: toIsoTimestamp(row.archived_at),
});

const mapMessage = (id, row = {}) => ({
  id,
  sender: row.sender || 'customer',
  message: row.message || '',
  attachment_url: row.attachment_url || null,
  attachment_name: row.attachment_name || null,
  attachment_type: row.attachment_type || null,
  created_at: toIsoTimestamp(row.created_at),
});

export async function subscribeToSupportChat(chatId, onData, onError) {
  const db = await getFirestoreDb();
  return onSnapshot(
    doc(db, 'support_chats', chatId),
    (snapshot) => {
      if (snapshot.exists()) {
        onData(mapChat(snapshot.id, snapshot.data()));
      }
    },
    onError
  );
}

export async function subscribeToSupportMessages(chatId, onData, onError) {
  const db = await getFirestoreDb();
  const messagesQuery = query(
    collection(db, 'support_chats', chatId, 'messages'),
    orderBy('created_at', 'asc')
  );

  return onSnapshot(
    messagesQuery,
    (snapshot) => {
      onData(snapshot.docs.map((messageDoc) => mapMessage(messageDoc.id, messageDoc.data())));
    },
    onError
  );
}

